<template>
  <Modal v-model="modelValue" :show-close="true">
    <template #title>{{ t('paymentDetails') }}</template>
    <PaymentDetailsContent
      :payment="payment"
      :booking-id="bookingId"
      :invoice="invoice"
      :initial-show-refund="initialShowRefund"
      :allocate-across-bookings="allocateAcrossBookings"
      :open="modelValue"
      @close="emit('update:modelValue', false)"
    />
  </Modal>
</template>

<script lang="ts" setup>
import type { Payment } from '@/entities/payments/payment.entity';
import Modal from '@/components/Modal.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch } from 'vue';
import type { Invoice } from '@/entities/invoices/invoice.entity';
import PaymentDetailsContent from './PaymentDetailsContent.vue';

const props = defineProps<{
  modelValue: boolean;
  payment: Payment;
  bookingId?: string;
  invoice?: Invoice;
  initialShowRefund?: boolean;
  allocateAcrossBookings?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const { t } = useI18n();

const modelValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    modelValue.value = val;
  },
);

watch(modelValue, () => {
  emit('update:modelValue', modelValue.value);
});
</script>

<i18n lang="json">
{
  "en": {
    "paymentDetails": "Payment Details"
  },
  "de": {
    "paymentDetails": "Zahlungsdetails"
  },
  "es": {
    "paymentDetails": "Detalle del pago"
  }
}
</i18n>
